import { SensorLockerStatus } from '@frontend/device/types';
import { MqttBroker } from '@frontend/pub-sub';
import { useEffect, useState } from 'react';

import { useWizardPackages } from '../../hooks/useWizardPackages';
import { useWizardTransaction } from '../../hooks/useWizardTransaction';
import { useScreen } from '../useScreen';

interface SensorData {
    data: {
        status?: SensorLockerStatus;
    };
    ids: {
        slot_id?: string;
        package_id?: string;
    };
    type: string;
}

export const useProcessOpenCloseSpotLayout = () => {
    const { store, navigationState } = useScreen();

    const { transaction } = useWizardTransaction({
        store,
        autoFetch: true
    });
    const { packages } = useWizardPackages({
        wizardId: store?.wizard.id,
        store
    });

    const [slotStatusMap, setSlotStatusMap] = useState<Map<string, SensorLockerStatus>>(new Map());
    // Initialize slot status map when packages change
    useEffect(() => {
        const statusMap = new Map<string, SensorLockerStatus>();
        packages.forEach((pkg) => {
            if (pkg.slot_id) {
                statusMap.set(pkg.slot_id, SensorLockerStatus.OPENED);
            }
        });
        setSlotStatusMap(statusMap);
    }, [packages]);

    //TODO should use package iform IOT
    const callback = (message: string, data: any) => {
        switch (message) {
            case 'device_sensor_received':
                handleDeviceSensor(data);
                break;
            default:
                break;
        }
    };

    const handleDeviceSensor = (data: any) => {
        const info = data as SensorData;
        if (info.ids.slot_id && info.data.status) {
            setSlotStatusMap((prevMap) => {
                const newMap = new Map(prevMap);
                newMap.set(info.ids.slot_id!, info.data.status!);
                return newMap;
            });
        }
    };

    useEffect(() => {
        if (navigationState.iot) {
            MqttBroker.getInstance().subscribe('process_open_close_slots_sensor', `iots/${navigationState.iot.id}/sensor`, callback);
        }
        return () => {
            if (navigationState.iot) {
                MqttBroker.getInstance().unSubscribe('process_open_close_slots_sensor', `iots/${navigationState.iot.id}/sensor`);
            }
        };
    }, []);

    return {
        slotStatusMap,
        functionality: store?.functionality,
        transaction,
        store
    };
};
